var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"logo"},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("../assets/succeed.png"),"mode":"aspectFit"}})]),_c('div',{staticClass:"text-box"},[_c('div',{staticClass:"text-item"},[_vm._v(" 感谢您的申请 ")]),_c('div',{staticClass:"item-item-t"},[_vm._v(" 申请成功！请等待人员审核 ")])])])
}]

export { render, staticRenderFns }